var render = function render(){var _vm=this,_c=_vm._self._c;return _c('figure',{staticClass:"image is-inline-block",class:_vm.canvasSize},[_c('img',{staticClass:"is-rounded has-shadow has-background-grey-light",style:({backgroundImage: `url(${_vm.$options.filters.getProfileImage(_vm.image, _vm.id, _vm.size)})`}),attrs:{"src":require("@/assets/images/spacer1_1.gif")}})])
}
var staticRenderFns = []

export { render, staticRenderFns }